[
  { "id": "adelaide-strikers", "name": "Adelaide Strikers", "aliases": ["Strikers", "Adelaide"] },
  { "id": "brisbane-heat", "name": "Brisbane Heat", "aliases": ["Heat", "Brisbane"] },
  { "id": "hobart-hurricanes", "name": "Hobart Hurricanes", "aliases": ["Hurricanes", "Hobart"] },
  { "id": "melbourne-renegades", "name": "Melbourne Renegades", "aliases": ["Renegades", "Gades"] },
  { "id": "melbourne-stars", "name": "Melbourne Stars", "aliases": ["Stars"] },
  { "id": "perth-scorchers", "name": "Perth Scorchers", "aliases": ["Scorchers", "Perth"] },
  { "id": "sydney-sixers", "name": "Sydney Sixers", "aliases": ["Sixers"] },
  { "id": "sydney-thunder", "name": "Sydney Thunder", "aliases": ["Thunder"] }
]
